// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.vendorsandpartners.vendor.CreateVendorLocationConfigRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateVendorLocationConfigRequest extends GandalfModelBase {

	@GandalfValidator({ sizeString: { message: 'Account # cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	accountNumber!: string | null;

	@GandalfValidator({ sizeString: { message: 'External/Ship-To # cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	externalLocationId!: string | null;

	@GandalfValidator({ sizeString: { message: 'Password cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	password!: string | null;

	@GandalfValidator({ notNull: { message: 'Location is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	practiceLocationId!: number;

	@GandalfValidator({ sizeString: { message: 'Username cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	userName!: string | null;

	@GandalfValidator({ notNull: { message: 'Vendor is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	vendorId!: number;

}
